import { faChevronDown } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon, TriggerWithDropdown } from '@seeqdev/qomponents';
import type { DropdownItems } from '@seeqdev/qomponents';

/** Shows workbook actions and submenus in the shared dropdown. */
export const WorkbookActionsMenu = ({
  items,
  accessibleName,
  isPending = false,
  setFocusOnTriggerOnClose = true,
}: {
  items: DropdownItems[];
  accessibleName: string;
  isPending?: boolean;
  setFocusOnTriggerOnClose?: boolean;
}) => (
  <span className="tw:inline-flex tw:rounded-sm tw:focus-within:ring-2 tw:focus-within:ring-sq-theme-link">
    <TriggerWithDropdown
      triggerIcon={
        <>
          <span className="tw:sr-only">{accessibleName}</span>
          <Icon icon={faChevronDown} type="inherit" />
        </>
      }
      align="start"
      alignOffset={0}
      extraClassNames="tw:cursor-pointer"
      aria-busy={isPending}
      setFocusOnTriggerOnClose={setFocusOnTriggerOnClose}
      dropdownItems={items}
    />
  </span>
);
